import styled from 'styled-components';

/**
 * A wrapper for `Dialog` close button content.
 *
 * @related [`Dialog`]
 * @since 8.54.0
 */
var DialogClose = /*#__PURE__*/styled.div.withConfig({
  displayName: "DialogClose",
  componentId: "c11n-8-111-1__sc-148f3kv-0"
})([""]);
DialogClose.displayName = 'DialogClose';

/** @component */
export { DialogClose };